<ng-template #alertHost></ng-template>
<div class="container mt-2" style="display: flex;height: 50vh;justify-content:center">
	<div class="profile_UI " *ngIf="profile">
		<div class="responsive-container bg_7 p_30">
			<div class="showForm">
				<div class="form-group">
					<label for="login">{{'LOGIN' | translate}}</label>
					<input type="text" id="login" [value]="profile.login" disabled>
					<span class="flexCLS"><i class='fas fa-lock' style='font-size:15px;color: #a9a9a9;'></i></span>
				</div>
				<div class="form-group" style="cursor: pointer;">
					<label for="Password">{{'PASSWORD' | translate}}</label>
					<input class="	Password_INPUT" type="text" id="Password" placeholder="XXXXXXXX"
						(click)="showUpdateProfile('UPDATEPASSWORD')"><span
						(click)="showUpdateProfile('UPDATEPASSWORD')" class="flexCLS"><i class='fas fa-pencil-alt'
							style='font-size:18px;color: #a9a9a9;'></i></span>
				</div>
				<div class="form-group">
					<label for="email">{{'EMAIL' | translate}}</label>
					<input type="text" id="email" [value]="profile.email" disabled>
					<span class="flexCLS"><i class='fas fa-lock' style='font-size:15px;color: #a9a9a9;'></i></span>

				</div>
				<!-- <div class="form-group">
					<label for="phone">Phone</label>
					<input type="text" id="phone" [value]="profile.address.phone" disabled>
					<span class="flexCLS"><i class='fas fa-lock' style='font-size:15px;color: #a9a9a9;'></i></span>

				</div> -->
				<div class="form-group">
					<label for="phone">{{'PHONE' | translate}}</label>

					<input type="text" id="phone" [value]="profile.address.phone" disabled>

					<span *ngIf="mobileValueStatus" class="flexCLS phone-edit-icon" (click)="showUpdatePhonePopup()">

						<i class="fas fa-pencil-alt" style="font-size:18px;color:#a9a9a9;">
						</i>

					</span>
				</div>

				<span class="form-group">
					<div class="form-group" *ngIf="profile.pixelURL">
						<label for="phone">{{'REFER_FRIEND' | translate}}</label>

						<input type="text" id="phone" [value]="profile.pixelURL" disabled>
						<span class="flexCLS copyIcon" (click)="copyMessage(profile.pixelURL)" title="Copy link"><i
								class='fas fa-copy'></i>
							<span *ngIf="showCopiedMessage" class="copied-msg">{{'COPIED' | translate}}</span>
						</span>

					</div>
				</span>
			</div>
		</div>
	</div>
</div>
<div class="cover_profile" *ngIf="!profile">
	<div class="spin">◌</div>
</div>
<div class="cover_profile" *ngIf="loader_up">
	<div class="spin">◌</div>
</div>
<div class="marg"></div>



<div class="phone-popup-cover" *ngIf="showPhonePopup">

	<div class="phone-popup">

		<h3>{{'Update_Mobile_Number' | translate}}</h3>
		<span>
			<div *ngIf="errorMessage" class="alert alert-danger">
				{{ errorMessage }}
			</div>
		</span>

		<input type="tel" pattern="[0-9]*" [(ngModel)]="newPhone" placeholder="{{'Enter_Mobile_Number' | translate }}" [disabled]="otpSent"
			(keypress)="allowNumbersOnly($event)">

		<!-- GET OTP -->
		<button class="otp-btn" *ngIf="!otpSent"
			[disabled]="isSendingOtp || newPhone.length < 11 || newPhone.length > 13" (click)="sendPhoneOtp()">

		{{ isSendingOtp ? ('Sending' | translate) : ('Get_OTP' | translate) }}

		</button>

		<!-- COUNTDOWN -->
		<button class="timer-btn" *ngIf="otpSent && countdown > 0 && !otpVerified" disabled>

			{{ countdown }}s

		</button>

		<!-- RESEND -->
		<button class="resend-btn" *ngIf="otpSent && countdown === 0 && !otpVerified" (click)="resendPhoneOtp()">

			 {{'Resend_OTP' | translate }}

		</button>

		<!-- OTP -->
		<div *ngIf="otpSent && !otpVerified">

			<input type="tel" maxlength="6" [(ngModel)]="enteredOtp" placeholder="Enter OTP" inputmode="numeric"
				pattern="[0-9]*" (keypress)="allowNumbersOnly($event)">

			<button class="verify-btn" [disabled]="enteredOtp.length !== 6 || isVerifyingOtp"
				(click)="verifyPhoneOtp()">

				{{ isVerifyingOtp ? ('Verifying' | translate) : ('Verify_OTP' | translate) }}

			</button>

			<div class="error" *ngIf="otpError">
			  {{'Invalid_OTP' | translate }}
			</div>

		</div>

		<!-- VERIFIED -->
		<div class="success" *ngIf="otpVerified">
			{{'OTP_Verified' | translate }} ✓
		</div>

		<!-- UPDATE PHONE -->
		<!-- <button class="submit-btn" *ngIf="otpVerified" [disabled]="isUpdatingPhone" (click)="updatePhoneNumber()">

			{{ isUpdatingPhone ? 'Updating...' : 'Update Mobile' }}

		</button> -->

		<button class="cancel-btn" (click)="closePhonePopup()">
			  {{'Cancel' | translate }}
		</button>

	</div>

</div>










<!-- <ng-template #alertHost></ng-template>
<div class="container mt-2" style="display: flex;height: 50vh;justify-content:center">
	<div class="profile_UI " *ngIf="profile">
		<div class="responsive-container bg_7 p_30">
			<div class="showForm">
				<div class="form-group">
					<label for="login">{{'LOGIN' | translate}}</label>
					<input type="text" id="login" [value]="profile.login" disabled>
					<span class="flexCLS"><i class='fas fa-lock' style='font-size:15px;color: #a9a9a9;'></i></span>
				</div>
				<div class="form-group" style="cursor: pointer;">
					<label for="Password">{{'PASSWORD' | translate}}</label>
					<input class="	Password_INPUT" type="text" id="Password" placeholder="XXXXXXXX"
						(click)="showUpdateProfile('UPDATEPASSWORD')"><span
						(click)="showUpdateProfile('UPDATEPASSWORD')" class="flexCLS"><i class='fas fa-pencil-alt'
							style='font-size:18px;color: #a9a9a9;'></i></span>
				</div>
				<div class="form-group">
					<label for="email">{{'EMAIL' | translate}}</label>
					<input type="text" id="email" [value]="profile.email" disabled>
					<span class="flexCLS"><i class='fas fa-lock' style='font-size:15px;color: #a9a9a9;'></i></span>

				</div>
				<div class="form-group">
					<label for="phone">Phone</label>
					<input type="text" id="phone" [value]="profile.address.phone" disabled>
					<span class="flexCLS"><i class='fas fa-lock' style='font-size:15px;color: #a9a9a9;'></i></span>

				</div>
				<span class="form-group" >
					<div class="form-group" *ngIf="profile.pixelURL">
						<label for="phone">{{'REFER_FRIEND' | translate}}</label>

						<input type="text" id="phone" [value]="profile.pixelURL" disabled>
						<span class="flexCLS copyIcon" (click)="copyMessage(profile.pixelURL)" title="Copy link"><i
								class='fas fa-copy'></i>
							<span *ngIf="showCopiedMessage" class="copied-msg">{{'COPIED' | translate}}</span>
						</span>

					</div>
				</span>
			</div>
		</div>
	</div>
</div>
<div class="cover_profile" *ngIf="!profile">
	<div class="spin">◌</div>
</div>
<div class="marg"></div> -->